/** Route a fired cue to the nodes a scene bound it to. Drawing the presentation is OVL-006. */

import type { RenderedDocument, ResolvedCueBinding } from "./sceneTree";

const WILDCARD = ".*";

/** Whether a binding pattern addresses this cue tag: an exact tag, or a `.*` prefix. */
export function cueTagMatches(pattern: string, tag: string): boolean {
  if (!pattern.endsWith(WILDCARD)) return pattern === tag;

  const prefix = pattern.slice(0, -WILDCARD.length);
  return tag === prefix || tag.startsWith(`${prefix}.`);
}

/** Every binding across the drawn documents this cue tag addresses, in document order. */
export function bindingsForCue(
  documents: readonly RenderedDocument[],
  tag: string,
): readonly ResolvedCueBinding[] {
  const matched: ResolvedCueBinding[] = [];

  for (const document of documents) {
    for (const binding of document.cueBindings) {
      if (cueTagMatches(binding.tagPattern, tag)) matched.push(binding);
    }
  }

  return matched;
}
